export const languages = [
  {
    name: 'ENGLISH',
    code: 'en',
  },
  {
    name: 'SPANISH',
    code: 'es',
  },
];
export const commonUnretrievableAttributes = ['body', 'objectID'];

// Exposed for client-side query string creation/parsing
export const facetingAttributePrefix = 'ALGOLIA_';

// Algolia's default ranking criteria. They recommend NOT changing this
export const defaultRanking = [
  'typo',
  'geo',
  'words',
  'filters',
  'proximity',
  'attribute',
  'exact',
];
export const commonRanking = [...defaultRanking, 'desc(entry_date.timestamp)'];
export const courseRanking = [
  ...defaultRanking,
  'desc(recent_minutes_watched)',
  'desc(entry_date.timestamp)',
];
